import { render, staticRenderFns } from "./PushEdit.vue?vue&type=template&id=ef8812fc&"
import script from "./PushEdit.vue?vue&type=script&lang=js&"
export * from "./PushEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports